/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { AgencyEventRankingIndividual } from "./Common/AgencyEventRankingIndividual";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>POST /api/v2/agency_event/ranking/group/get_individual</strong>
 * 事務所イベントグループ内個人ランキング情報を取得
 */
export interface AgencyEventRankingGetGroupIndividualRequest {
  /** @deprecated */
  eventId: number;
  groupId: number;
  eventKey: string;
}

export interface AgencyEventRankingGetGroupIndividualResponse {
  rankingList: AgencyEventRankingIndividual[];
}

function createBaseAgencyEventRankingGetGroupIndividualRequest(): AgencyEventRankingGetGroupIndividualRequest {
  return { eventId: 0, groupId: 0, eventKey: "" };
}

export const AgencyEventRankingGetGroupIndividualRequest = {
  encode(message: AgencyEventRankingGetGroupIndividualRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eventId !== 0) {
      writer.uint32(8).int64(message.eventId);
    }
    if (message.groupId !== 0) {
      writer.uint32(16).int64(message.groupId);
    }
    if (message.eventKey !== "") {
      writer.uint32(26).string(message.eventKey);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGetGroupIndividualRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGetGroupIndividualRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eventId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.groupId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.eventKey = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGetGroupIndividualRequest {
    return {
      eventId: isSet(object.eventId) ? globalThis.Number(object.eventId) : 0,
      groupId: isSet(object.groupId) ? globalThis.Number(object.groupId) : 0,
      eventKey: isSet(object.eventKey) ? globalThis.String(object.eventKey) : "",
    };
  },

  toJSON(message: AgencyEventRankingGetGroupIndividualRequest): unknown {
    const obj: any = {};
    if (message.eventId !== 0) {
      obj.eventId = Math.round(message.eventId);
    }
    if (message.groupId !== 0) {
      obj.groupId = Math.round(message.groupId);
    }
    if (message.eventKey !== "") {
      obj.eventKey = message.eventKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGetGroupIndividualRequest>, I>>(
    base?: I,
  ): AgencyEventRankingGetGroupIndividualRequest {
    return AgencyEventRankingGetGroupIndividualRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGetGroupIndividualRequest>, I>>(
    object: I,
  ): AgencyEventRankingGetGroupIndividualRequest {
    const message = createBaseAgencyEventRankingGetGroupIndividualRequest();
    message.eventId = object.eventId ?? 0;
    message.groupId = object.groupId ?? 0;
    message.eventKey = object.eventKey ?? "";
    return message;
  },
};

function createBaseAgencyEventRankingGetGroupIndividualResponse(): AgencyEventRankingGetGroupIndividualResponse {
  return { rankingList: [] };
}

export const AgencyEventRankingGetGroupIndividualResponse = {
  encode(message: AgencyEventRankingGetGroupIndividualResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.rankingList) {
      AgencyEventRankingIndividual.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGetGroupIndividualResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGetGroupIndividualResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.rankingList.push(AgencyEventRankingIndividual.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGetGroupIndividualResponse {
    return {
      rankingList: globalThis.Array.isArray(object?.rankingList)
        ? object.rankingList.map((e: any) => AgencyEventRankingIndividual.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgencyEventRankingGetGroupIndividualResponse): unknown {
    const obj: any = {};
    if (message.rankingList?.length) {
      obj.rankingList = message.rankingList.map((e) => AgencyEventRankingIndividual.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGetGroupIndividualResponse>, I>>(
    base?: I,
  ): AgencyEventRankingGetGroupIndividualResponse {
    return AgencyEventRankingGetGroupIndividualResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGetGroupIndividualResponse>, I>>(
    object: I,
  ): AgencyEventRankingGetGroupIndividualResponse {
    const message = createBaseAgencyEventRankingGetGroupIndividualResponse();
    message.rankingList = object.rankingList?.map((e) => AgencyEventRankingIndividual.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
